
const sortHelper = <T>(a: T[], b: T[], key: string) => {
  if (a[key] > b[key]) {
    return 1;
  }
  if (a[key] < b[key]) {
    return - 1;
  }
  return 0; 
}

const sortHelperWithNullvalues = <T>(a: T[], b: T[], key: string) => {
 
  const aInt = Number(a[key]);
  const bInt = Number(b[key]);

  if(!a[key] || !b[key]){
    return  sortNullValuesEndOfList(a[key], b[key]);
  }
  
  if(Number.isInteger(aInt) && Number.isInteger(bInt)){
    return aInt - bInt
  } else {
    if (a[key] > b[key]) { 
      return 1;
    }
    if (a[key] < b[key]) {
      return - 1;
    }
    return 0; 
  }
}
 
const sortNullValuesEndOfList = (a: string, b: string)=>{
    if(!a && b){
      return 1
    }else if(a && !b){
      return -1
    }else{
      return 0
    }
} 

export {
  sortHelper,
  sortHelperWithNullvalues
}
